import { SDK_SEASON, NFLWeekAbbreviation } from '@pff-consumer/schema'

export const bettingEndpoints = {
  getPlayerProps: ({ season = SDK_SEASON, weekAbv }: { season: number; weekAbv: NFLWeekAbbreviation }) => ({
    url: `football/v2/betting/nfl/${season}/player-props/${weekAbv}`,
  }),
}
